import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-77-small', 'Number77Small', [["path",{"d":"M14 8h4l-2 8"}],["path",{"d":"M6 8h4l-2 8"}]]);